
















import { TooltipPlacement } from '@getaccept/lib-shared/src/enums/tooltip-placement';
import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import { AvatarSize } from '@getaccept/lib-ui';
import { useAvatars } from '@getaccept/lib-shared/src/composables/avatars.composable';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';

export default defineComponent({
  name: 'SlideMenuTop',
  props: {
    dsrName: {
      type: String,
      default: '',
    },
    createdAt: {
      type: String,
      default: '',
    },
    recipients: {
      type: Array as PropType<Array<Recipient>>,
      default: () => [],
    },
  },
  setup() {
    const { getRecipientAvatars } = useAvatars();

    return {
      TooltipPlacement,
      AvatarSize,
      getRecipientAvatars,
    };
  },
});
